import {fetch} from "utils/dataAccess";

export function error(error) {
    return {type: "CATEGORY_DELETE_SELECTION_ERROR", error};
}

export function loading(loading) {
    return {type: "CATEGORY_DELETE_SELECTION_LOADING", loading};
}

export function success(deleted) {
    return {type: "CATEGORY_DELETE_SELECTION_SUCCESS", deleted};
}

export function deleteSelection(categories) {
    return dispatch => {
        dispatch(loading(true));

        return fetch('/categories/delete_selection', {method: "POST", body: JSON.stringify({categories: categories})})
            .then(() => {
                dispatch(loading(false));
                dispatch(success(categories));
            })
            .catch((e) => {
                dispatch(loading(false));
                dispatch(error(e.message));
            });
    };
}